import { Inject, Injectable } from '@angular/core';

import { ApiException } from "../models"
import { ErrorCodes } from "../../../shared/errorCodes";
import { RouteRedirector } from "./routeRedirector";
import { AccountDataStore } from "./accountData";
import { Exception } from "../../../shared/exception";
import { HttpException } from '../../../shared/httpException';
import { BroadcastChannelService, BroadcastChannelMessageType } from './BroadcastChannelService';

@Injectable()
export class HttpErrorCodeHandler {

  constructor(
    @Inject(RouteRedirector) protected routeRedirector: RouteRedirector,
    @Inject(AccountDataStore) protected accountStore: AccountDataStore,
    @Inject(BroadcastChannelService) protected broadcastChannelService: BroadcastChannelService
  ) { }

  public handle(httpException: HttpException) {
    
    let exceptions: Exception[] = httpException.exceptions;
    if (!exceptions || exceptions.length == 0)
      return;

    let apiException = exceptions.find((ex) => ex instanceof ApiException);
    if (apiException instanceof ApiException) {

      if (httpException.errorResponse.status == 401) {
        // Remove user session only if authentication or work session has expired, or if the amount of active users have been exceeded.
        if (apiException.code == ErrorCodes.AUTHENTICATION_EXPIRED || apiException.code == ErrorCodes.WORK_SESSION_EXPIRED || apiException.code == ErrorCodes.ACTIVE_USERS_COUNT_EXCEEDED) {
          this.accountStore.getLoggedInUser();
          this.broadcastChannelService.send(BroadcastChannelMessageType.LogOutUser);
        }
        
        // Redirect to login with returnurl to start page
        this.routeRedirector.redirectToLogin('start');
      }      
    }
  }
}